import styled from 'styled-components';

import { fromLarge } from 'styleUtils/mediaQueries';

export const Description = styled.div`
    text-align: justify;
    line-height: 2em;
    *:last-child {
        margin-bottom: 0;
    }

    ${fromLarge`
        max-width: 75%;
        margin: 0 auto;
    `};
`;
